import styled from '@emotion/styled'
import { Box, TextField, Typography } from '@mui/material'
import { CSSProperties } from 'react'
import { Control, Controller } from 'react-hook-form'

const LabelNameBox = styled(Box)(() => ({
	display: 'flex',
	width: '30%'
}))

export const FormTextField = (props: {
	name: string
	control: Control<any>
	label: string
	uneditable?: boolean
	sx?: CSSProperties
	type?: 'password' | 'number' | 'tel' | 'email'
	mandatory?: boolean
	fullWidth?: boolean
}) => {
	return (
		<>
		<Controller
			name={props.name}
			control={props.control}
			render={({ field: { onChange, value }, fieldState: { error } }) => {
				if (props.fullWidth) {
					return (
						<TextField
							onChange={onChange}
							value={value || ''}
							variant="standard"
							sx={{
								width: '100%',
								...props.sx,
								input: {
									color: 'black',
								},
							}}
							disabled={props.uneditable}
							type={props?.type ?? 'text'}
							error={!!error}
							
						/>
						
					)
				} else {
					return (
						<Box
							sx={{
								flexDirection: 'row',
								
								width: '100%',
								alignItems: 'flex-end',
								height: '40px',
								marginRight: '30px',
								marginBottom: '10px',
							}}
						>
							<Box sx={{display: 'flex'}}>
							<LabelNameBox>
								<Typography variant="h6" color={!!error ? 'error' : 'info'}>
									{props.label}
									{props.mandatory && '*'} :
								</Typography>
							</LabelNameBox>
							<TextField
								onChange={onChange}
								value={value || ''}
								variant="standard"
								sx={{
									width: '80%',
									...props.sx,
									input: {
										color: 'black',
										fontSize: '16px'
									},
								}}
								disabled={props.uneditable}
								type={props?.type ?? 'text'}
								error={!!error}
								
							/>
							</Box>
							{error && <Typography color='red' fontSize={15}>{error?.message}</Typography>}
						</Box>
					)
				}
			}}
		/>
		
		</>
		
	)
}
